import { UserAccountType } from "@/models/user-account-type.model";
import type { UserListItem } from "@/models/user.model";
import { DropdownCell } from "@spz/ui/components/table/cells/dropdown-cell";
import { useTranslation } from "react-i18next";
import { useUpdateUserAccountType } from "../../hooks/use-update-user-account-type";

type AccountTypeDropdownCellProps = {
  accountType: UserAccountType;
  user: UserListItem;
};

export const AccountTypeDropdownCell = ({
  accountType,
  user,
}: AccountTypeDropdownCellProps) => {
  const { t } = useTranslation();
  const options = UserAccountType.getOptions().map((option) => ({
    value: option.value,
    label: t(option.labelKey),
    description: t(option.descriptionKey),
  }));
  const { updateUserAccountType } = useUpdateUserAccountType();

  const handleChange = (value: UserAccountType, userId: UserListItem["id"]) => {
    updateUserAccountType({ userId, accountType: value });
  };

  return (
    <DropdownCell
      options={options}
      value={accountType.value}
      onChange={(value) =>
        handleChange(UserAccountType.fromValue(value), user.id)
      }
    />
  );
};
